// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import MultiplySafetyAnchorPointRequestModel from '../../model/multiply-safety-anchor-point-request-model';
import MultiplySafetyAnchorPointRequestDTO from '../dto/multiply-safety-anchor-point-request-dto';
import dtoSchema from '../schemas/multiply-safety-anchor-point-request-schema';

export default abstract class MultiplySafetyAnchorPointRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<MultiplySafetyAnchorPointRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.count = data.count;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int32}
  */
  count?: number;

  static toModel(dto: DeepPartial<MultiplySafetyAnchorPointRequestDTO>): MultiplySafetyAnchorPointRequestModel;
  static toModel(dto: DeepPartial<MultiplySafetyAnchorPointRequestDTO> | undefined | null): MultiplySafetyAnchorPointRequestModel | undefined;
  static toModel(dto: DeepPartial<MultiplySafetyAnchorPointRequestDTO> | undefined | null): MultiplySafetyAnchorPointRequestModel | undefined {
    return dto ? new MultiplySafetyAnchorPointRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<MultiplySafetyAnchorPointRequestModel> | MultiplySafetyAnchorPointRequestModel): MultiplySafetyAnchorPointRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      count: unwrapped.count,
    } as MultiplySafetyAnchorPointRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for MultiplySafetyAnchorPointRequestModel, can not map to MultiplySafetyAnchorPointRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
